<template>
  <div>
    <WmtHeader :activeKey='activeKey'></WmtHeader>
    <div id="singleModule" style="height:auto;">
      <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/website/liveServerBg.png" alt="" class="topbg">
    </div>

    <div id="singleModule" style="background: #f8f8f8;height:800px;">
      <div class="moduleContainer" style="padding-top:47px;">
        <div class="title">
          <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/website/liveIcon.png" alt="icon" class="icon">
          <h3 class="title_content">才艺主播</h3>
        </div>

        <!-- 主播列表 -->
        <div class="anchorList">
          <div class="anchorItem" v-for="(item, index) in zhuboList" :key='index' @click="goDetail(item)">
            <img :src="item.img" alt="" class="img">
            <div class="bottom">
              <div class="name">{{item.name}}</div>
              <div class="count"> <i class="iconfont wemeet-renqi"></i> {{item.count}}</div>
            </div>
            <div class="playBtn">
              <i class="wemeet-bofanganniu iconfont"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部通栏 -->
    <WmtFooter></WmtFooter>
  </div>
</template>

<script>
import WmtHeader from '@/components/layout/wmtHeader.vue'
import WmtFooter from '@/components/layout/wmtFooter.vue'
export default {
  name: 'Home',
  components: {
    WmtHeader,
    WmtFooter,
  },
  data() {
    return {
      activeKey: 'live',
      zhuboList: [
        {
          img: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/website/liveServer/zhubo1.png',
          name: '王宇坤',
          count: Math.floor(Math.random() * 5000),
          id: 1,
        },
        {
          img: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/website/liveServer/zhubo2.png',
          name: '文儿',
          count: Math.floor(Math.random() * 5000),
          id: 2,
        },
        {
          img: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/website/liveServer/zhubo3.png',
          name: '柠檬有点甜',
          count: Math.floor(Math.random() * 5000),
          id: 3,
        },
        {
          img: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/website/liveServer/zhubo4.png',
          name: '陈晨',
          count: Math.floor(Math.random() * 5000),
          id: 4,
        },
      ],
    }
  },
  methods: {
    goDetail(e) {
      this.$router.push({ path: '/liveDetail', query: { id: e.id } })
    },
  },
}
</script>

<style lang="less" scoped>
.topbg {
  width: 100%;
  height: 210px;
}

.title {
  display: flex;
  .icon {
    width: 33px;
    height: 33px;
  }
  .title_content {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-left: 10px;
  }
}

.anchorList {
  display: grid;
  grid-template-columns: auto auto auto auto;
  margin-top: 53px;
  cursor: pointer;
  .anchorItem {
    width: 231px;
    height: 286px;
    background: #fff;
    border-radius: 8px;
    position: relative;
    .playBtn {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: #ffffff;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      line-height: 60px;
      opacity: 0;
      .iconfont {
        color: #5abec1;
        font-size: 20px;
      }
    }
    &:hover {
      background: #5abec1;
      .playBtn {
        opacity: 1;
      }
      .img {
        webkit-transform: scale(0.97);
        -moz-transform: scale(0.97);
        -ms-transform: scale(0.97);
        -o-transform: scale(0.97);
        transform: scale(0.97);
        -webkit-transition: transform 1s linear;
        -moz-transition: transform 1s linear;
        -ms-transition: transform 1s linear;
        -o-transition: transform 1s linear;
        transition: transform 1s linear;
      }
      .bottom {
        .name {
          color: #fff;
        }
        .count {
          color: #fff;
          .wemeet-renqi {
            color: #fff;
          }
        }
      }
    }
    .bottom {
      padding: 14px 15px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .name {
        color: #333333;
      }
      .count {
        color: #333333;
        .wemeet-renqi {
          color: #F28467;
        }
      }
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
}
</style>